import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BQLink } from '../bqlink';
import get from 'lodash/get';
import { clickPreferredSourceBadge } from '../../../helpers/datalayer-utils';
import { useScrollTrigger } from '../../../helpers/custom-hooks';
import './google-preferred-badge-strip.m.css';

const GooglePreferredBadgeStrip = ({ story = {}, position = '' }) => {
  const hasUserAction = useScrollTrigger(600);
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(false);

  const googleBadge = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'google_badge_content'], {}),
  );

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          setScrolled(scrollY > 1200);
          setVisible(scrollY > 600);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!hasUserAction || !googleBadge?.link || !visible) return null;

  return (
    <div
      styleName={`google-preferred-badge`}
      onClick={() => clickPreferredSourceBadge(story, position)}
      className="mobile-only"
    >
      <div styleName={`badge-container ${scrolled ? 'short-badge' : ''}`}>
        <BQLink href={googleBadge?.link} target={googleBadge?.target || '_self'}>
          <div styleName="image-container">
            <img
              styleName={`badge-image ${scrolled ? 'hide' : 'show'}`}
              src="/images/PreferredSourceBadge.gif"
              alt="Google Badge"
              height="39px"
              width="110px"
            />
            <img
              styleName={`badge-image circle ${scrolled ? 'show' : 'hide'}`}
              src="/images/google-circle.png"
              alt="Google Badge"
              height="38px"
              width="38px"
            />
          </div>
        </BQLink>
      </div>
    </div>
  );
};

export default GooglePreferredBadgeStrip;
